import PlusIcon from "@heroicons/react/24/outline/PlusIcon";
import TrashIcon from "@heroicons/react/24/solid/TrashIcon";
import { IQuestionAnswerLocalizedDto } from "../../../interfaces/endpoints/IFAQ";

interface Props {
  faqs: IQuestionAnswerLocalizedDto[];
  selectedId: number | null;
  onSelect: (faq: IQuestionAnswerLocalizedDto) => void;
  onAdd: () => void;
  onDelete: (answerId: number) => void;
}

const FAQList = ({ faqs, selectedId, onSelect, onAdd, onDelete }: Props) => (
  <div className="w-1/3 border rounded-lg p-3 max-h-[600px] overflow-y-auto">
    <div className="flex items-center justify-between mb-3">
      <h3 className="text-sm font-medium">FAQs</h3>
      <button
        type="button"
        onClick={onAdd}
        className="p-1 hover:bg-primary/10 rounded"
      >
        <PlusIcon className="w-5 h-5 text-primary" />
      </button>
    </div>
    {faqs.length === 0 && (
      <p className="text-sm text-gray-500">Nuk ka FAQ akoma</p>
    )}
    {faqs.map((faq) => (
      <div
        key={faq.answerId}
        className={
          "flex items-center justify-between border-b py-2 "
          + "last:border-0 cursor-pointer hover:bg-gray-50 px-2 rounded "
          + (selectedId === faq.answerId ? "bg-primary/10" : "")
        }
      >
        <button
          type="button"
          onClick={() => onSelect(faq)}
          className="text-left text-sm truncate flex-1"
        >
                {faq.localizedQuestions?.[0]?.question || "Pa titull"}
        </button>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onDelete(faq.answerId);
          }}
          className="ml-2 p-1 hover:bg-red-50 rounded"
        >
          <TrashIcon className="w-4 h-4 text-red-500" />
        </button>
      </div>
    ))}
  </div>
);

export default FAQList;
